var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99692 0.503906C6.18724 0.503906 6.36106 0.611957 6.44529 0.782626L7.8719 3.6733L11.0616 4.13558C11.2501 4.16289 11.4067 4.29487 11.4655 4.47598C11.5243 4.65708 11.4751 4.85587 11.3387 4.98869L9.0272 7.23868L9.57222 10.4159C9.60442 10.6035 9.52722 10.7932 9.37313 10.9051C9.21903 11.0169 9.01478 11.0315 8.84633 10.9427L6.00016 9.44294L3.1471 10.943C2.97864 11.0315 2.7745 11.0168 2.62053 10.9049C2.46655 10.793 2.38944 10.6035 2.42162 10.4159L2.96664 7.23868L0.655165 4.98869C0.518717 4.85587 0.469555 4.65708 0.528368 4.47598C0.58718 4.29487 0.743758 4.16289 0.932206 4.13558L4.12194 3.6733L5.54855 0.782626C5.63278 0.611957 5.8066 0.503906 5.99692 0.503906Z",
    fill: "#F29036"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.bd2fac62fbaf8584d791899486f27e6d.svg";
export { ForwardRef as ReactComponent };